import styled from 'styled-components'

export const HeaderWrapper = styled.div`
  margin: 0 auto;
  padding: 0 1em;
  max-width: 1140px;
  text-align: center;
`